import { all } from 'redux-saga/effects';
import { BASE_ACTIONS } from './NDFL3SagaActionTypes';
import {
  calculateDeduction,
  calculateTotalIncomeSums,
  getIncomeSourceBy2ndflId,
  getMonthIncomes,
  save3NDFLasDraftAndExit,
  save3NDFLDraft,
  updateDeductionsByIncomeTypeCode,
  updateDependentGameDeductionFields,
  updateIncomeRates,
  updateReceiptsList,
  updateTaxPaymentRates,
} from './NDFL3Saga';
import { goPrevStepSaga, goToStep, initNDFL3PageSaga, saveAndGoNextStep } from './Ndfl3BeforeSteps';
import NDFL3OvepayementDisposalSagas from 'modules/Taps/redux/ndfl3Saga/NDFL3OvepayementDisposalSagas';

export function* getNDFL3Sagas() {
  yield all([
    BASE_ACTIONS.GET_TAX_DEDUCTION_OWNER_CODES.buildSagaFunction(),
    BASE_ACTIONS.GET_OBJECT_NAME_CODES.buildSagaFunction(),
    BASE_ACTIONS.GET_FILES_CATEGORIES.buildSagaFunction(),
    BASE_ACTIONS.GET_PROPERTY_RIGHTS.buildSagaFunction(),
    BASE_ACTIONS.GET_INCOME_TAX_TYPES.buildSagaFunction(),
    BASE_ACTIONS.GET_DEDUCTIONS_TAX_TYPES.buildSagaFunction(),
    BASE_ACTIONS.GET_TAX_PAYER_CATEGORIES.buildSagaFunction(),
    BASE_ACTIONS.GET_ACION_TYPES_FOR_LAWYERS_INCOME.buildSagaFunction(),
    BASE_ACTIONS.GET_CHILD_DEDUCTIONS.buildSagaFunction(),
    goPrevStepSaga(),
    initNDFL3PageSaga(),
    saveAndGoNextStep(),
    updateIncomeRates(),
    updateTaxPaymentRates(),
    getIncomeSourceBy2ndflId(),
    save3NDFLasDraftAndExit(),
    goToStep(),
    getMonthIncomes(),
    calculateTotalIncomeSums(),
    calculateDeduction(),
    updateDependentGameDeductionFields(),
    updateReceiptsList(),
    save3NDFLDraft(),
    updateDeductionsByIncomeTypeCode(),
    NDFL3OvepayementDisposalSagas(),
  ]);
}
